import {FormControl} from '@angular/forms';

export function showServerValidationErrors(errors: ValidationErrorItem[], map: (item: ValidationErrorItem) => FormControl<any>): void {
    errors.forEach(item => {
        const field = map(item);

        if (field) {
            field.setErrors({serverError: item.message});
            field.markAsTouched();

            const subscription = field.valueChanges.subscribe(() => {
                field.setErrors({serverError: null});
                field.updateValueAndValidity({emitEvent: false});
                subscription.unsubscribe();
            });
        }
    });
}

export function parseFieldExpression(expression?: string, collection = ''): ParsedFieldExpression {
    if (!expression) {
        return {
            index: 0,
            field: ''
        };
    }

    const escaped = collection.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const regex = new RegExp(`^${escaped}(?:\\[(\\d+)\\])?\\.?(.*)$`);

    const match = expression.trim().match(regex);

    if (!match) {
        return {
            index: 0,
            field: expression
        };
    }

    return {
        index: match[1] !== undefined ? parseInt(match[1], 10) : 0,
        field: match[2]
    };
}

export interface ValidationErrorItem {
    field: string;
    code: string;
    message: string;
}

export interface ParsedFieldExpression {
    index: number;
    field: string;
}
